/* -------------------------------------------------------------------------- */
/*                                Avatar styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-avatar.variables';

:host {
  @apply relative inline-block;
}

.bq-avatar {
  @apply relative overflow-hidden bg-[var(--bq-avatar-background)];
  @apply border-[length:var(--bq-avatar--border-width)] border-[color:var(--bq-avatar--border-color)];

  border-style: var(--bq-avatar--border-style);
}

.size {
  &--xsmall {
    @apply text-[length:var(--bq-avatar--font-size-xsmall)] bs-[--bq-avatar--size-xsmall] is-[--bq-avatar--size-xsmall];
  }

  &--small {
    @apply text-[length:var(--bq-avatar--font-size-small)] bs-[--bq-avatar--size-small] is-[--bq-avatar--size-small];
  }

  &--medium {
    @apply text-[length:var(--bq-avatar--font-size-medium)] bs-[--bq-avatar--size-medium] is-[--bq-avatar--size-medium];
  }

  &--large {
    @apply text-[length:var(--bq-avatar--font-size-large)] bs-[--bq-avatar--size-large] is-[--bq-avatar--size-large];
  }
}
